import SmartTrafficExampleImage from '../assets/img/ExampleImages/smart-traffic.png';
import SmartTrafficConditionImage from '../assets/img/ExampleImages/smart-traffic-condition.png';
import ParksuchverkehrImage from '../assets/img/ExampleImages/parksuchverkehr.png';
import ParkverteilungImage from '../assets/img/ExampleImages/parkverteilung.png';
import QuelleZielAuswertungImage from '../assets/img/ExampleImages/quelle-ziel-auswertung.png';
import SmartEmissionsImage from '../assets/img/ExampleImages/smart-emissions.png';
import SmartEmissionsImage_v2 from '../assets/img/ExampleImages/smart-emissions-v2.png';
import SmartIllegalParkingImage from '../assets/img/ExampleImages/smart-illegal-parking.png';
import SmartNaturalEventsImage from '../assets/img/ExampleImages/smart-natural-events.png';
import SmartNoiseImage from '../assets/img/ExampleImages/smart-noise.png';
import SmartParkenImage from '../assets/img/ExampleImages/smart-parken.png';
import HeatIslandImage from '../assets/img/ExampleImages/heat-island.png';
import SmartHeatIslandImage from '../assets/img/ExampleImages/smart-heat-island.png';
import SmartPedestrianImage from '../assets/img/ExampleImages/smart-pedestrian.png';
import VerkersaufkommenImage from '../assets/img/ExampleImages/verkersaufkommen.png';
import SmartSurfaceWaterImage from '../assets/img/ExampleImages/surface-water.png';
import VerlustzeitenImage from '../assets/img/ExampleImages/verlustzeiten.png';
import VerkersspinneImage from '../assets/img/ExampleImages/verkersspinne.png';
import LevelOfServiceImage from '../assets/img/ExampleImages/level-of-service.png';
import SmartEnergyMonitoringImage from '../assets/img/ExampleImages/energy-monitoring.png';
import SmartWasteDisposalImage from '../assets/img/ExampleImages/waste-disposal.png';
import SmartWaterLevelImage from '../assets/img/ExampleImages/water-level.png';
import SmartFloodRiskImage from '../assets/img/ExampleImages/flood-risk.png';
import SmartFloodRiskManagerImage from '../assets/img/ExampleImages/flood-risk-manager.png';
import SmartAverageSpeedImage from '../assets/img/ExampleImages/smart-average-speed.png';
import SmartEnvironmentExampleImage from '../assets/img/ExampleImages/smart-environment.png';
import M2L_1Image from '../assets/img/ExampleImages/M2L_1.png';
import M2L_2Image from '../assets/img/ExampleImages/M2L_2.png';
import M2L_3Image from '../assets/img/ExampleImages/M2L_3.png';
import Rodgau_1Image from '../assets/img/ExampleImages/rodgau_1.png';
import Rodgau_2Image from '../assets/img/ExampleImages/rodgau_2.png';
import SmartTrafficFlowExampleImage from '../assets/img/ExampleImages/smart-traffic-flow.png';
import SmartParkingSpotsImage from '../assets/img/ExampleImages/smart-parking-spots.png';
import DownloadManagerImage from '../assets/img/ExampleImages/download-manager.png';
import ParkdauerImage from '../assets/img/ExampleImages/parkdauer.png';
import QuestionnaireImage from '../assets/img/ExampleImages/questionnaire.png';
import QuestionnaireOverviewImage from '../assets/img/ExampleImages/questionnaire-overview.png';
import WinterServiceImage from '../assets/img/ExampleImages/winter-service.png';
import PartlyCloudyDay from '../assets/icons/kiwa/sun-cloud';
import { FaTint, FaRoad, FaWalking, FaSmog, FaTrafficLight, FaShareAlt, FaMapMarkedAlt, FaTrash, FaCaravan, FaWater } from 'react-icons/fa';
import { GiSoundWaves, GiSpiderWeb } from "react-icons/gi";
import { MdDirectionsCar, MdMood, MdOutlineLocalParking, MdOutlineTimer } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { IoIosWater } from "react-icons/io";
import { IoSpeedometer, IoTicket } from "react-icons/io5";
import Car from "../assets/icons/cars";
import IconParkAndCharge from "../assets/icons/icon_park-and-charge";
import Temperature from '../assets/icons/demoIcons/temperature';
import { IconType } from 'react-icons/lib';
import CloudDownload from '../assets/icons/demoIcons/cloud-download';
import { RiFloodFill } from "react-icons/ri";
import { SiFlood } from "react-icons/si";
import { FaHandHoldingWater } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { IoIosRainy } from "react-icons/io";
import appConfig, { trafficAnalyzerUrl } from './appConfig';
import { FaCloudDownloadAlt } from "react-icons/fa";
import { FaRegClipboard } from "react-icons/fa";
import { FaChartPie } from "react-icons/fa";
import { GiBurningForest } from "react-icons/gi";
import ForestFireMonitoringImage from '../assets/img/ExampleImages/forest-fire-monitoring.png';
import ForestFireVulnerabilityImage from '../assets/img/ExampleImages/forest-fire-vulnerability.png';
import WeatherMonitoringImage from '../assets/img/ExampleImages/weather-monitoring.png';
import { FaSnowplow } from "react-icons/fa";
import WeatherMeteoblueMapImage from '../assets/img/ExampleImages/weather-meteoblue-map.png';
import ForestHealthImage from '../assets/img/ExampleImages/forest-health.png';
import ForestHealthManagerImage from '../assets/img/ExampleImages/forest-health-manager.png';
import { MdOutlineForest } from "react-icons/md";
import { MdInsights } from "react-icons/md";
import { BsClipboardPulse } from "react-icons/bs";
import SpendingPulseImage from '../assets/img/ExampleImages/spending-pulse.png';
import GeoInsightsImage from '../assets/img/ExampleImages/geo-insights.png';
import { PiTrafficConeFill } from 'react-icons/pi';
import AgorgaFCDImage from '../assets/img/ExampleImages/agora-fcd.jpg';
import { FaArrowUpFromWaterPump, FaSunPlantWilt } from "react-icons/fa6";
import BikeTrafficImage from '../assets/img/ExampleImages/bike-traffic.png';
import PedestrianTrafficImage from '../assets/img/ExampleImages/pedestrian-traffic.png';
import { MdDirectionsBike } from "react-icons/md";
import SingleParkingIcon from "../assets/icons/icon_single-parking";
import ParkingGarageIcon from "../assets/icons/icon_parking-garage";
import RealTimeTrafficImage from '../assets/img/ExampleImages/real-time-traffic.png';
import SmartRealTimeTrafficImage from '../assets/img/ExampleImages/smart-real-time-traffic.png';
import ParkverstoesseImage from '../assets/img/ExampleImages/parkverstoesse.png';
import { BsFillSignNoParkingFill } from "react-icons/bs";
import { MdFireTruck } from "react-icons/md";
import { FaWind } from "react-icons/fa";
import ParkingMeterAnalysisImage from '../assets/img/ExampleImages/parking-meter-analysis.png';
import SmartPedestrianOccupancyImage from '../assets/img/ExampleImages/pedestrian-occupation.png';
import { TbMapCog } from 'react-icons/tb';

type IconProps = {
    color: string;
    size?: number;
};

export interface TileData {
    id: string;
    titleKey: string;
    subtitleKey: string;
    descriptionKey: string;
    image: string;
    categories: string[]; // Changed from string to string[]
    navigateTo: string;
    linkTo?: string;
    icon: IconType | React.FC<{ color: string; size?: number }>;
    tabs?: string[];
}

export const tilesData: TileData[] = [
    {
        id: 'SmartTraffic',
        titleKey: 'tiles.smartTraffic.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartTrafficExampleImage,
        categories: ['traffic'],
        navigateTo: '/SmartTraffic',
        icon: Car,
    },
    {
        id: 'SmartTrafficFlow',
        titleKey: 'tiles.smartTrafficFlow.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartTrafficFlowExampleImage,
        categories: ['traffic'],
        navigateTo: '/SmartTrafficFlow',
        icon: Car,
        tabs: ['Fließender Verkehr', "Fließender Verkehr mit FCD"],
    },
    {
        id: 'SmartTrafficCondition',
        titleKey: 'tiles.smartTrafficCondition.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartTrafficConditionImage,
        categories: ['traffic'],
        navigateTo: '/SmartTrafficCondition',
        icon: FaMapMarkedAlt,
    },
    {
        id: 'SmartParking',
        titleKey: 'tiles.smartParking.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartParkenImage,
        categories: ['traffic'],
        navigateTo: '/SmartParking',
        icon: MdOutlineLocalParking,
        tabs: ['Ruhender Verkehr (Bilanzierendes Parken) mit FCD', 'Ruhender Verkehr (Bilanzierendes Parken)'],
    },
    {
        id: 'SmartParkingSpots',
        titleKey: 'tiles.smartParkingSpots.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartParkingSpotsImage,
        categories: ['traffic'],
        navigateTo: '/SmartParkingSpots',
        icon: MdOutlineLocalParking,
        tabs: ['Ruhender Verkehr (Einzelplatzdetektion)', 'Ruhender Verkehr (Einzelplatzdetektion) mit FCD'],
    },
    {
        id: 'SmartMotorhomeTraffic',
        titleKey: 'tiles.smartMotorhomeTraffic.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartParkingSpotsImage,
        categories: ['traffic'],
        navigateTo: '/SmartMotorhomeTraffic',
        icon: FaCaravan,
        tabs: ['Ruhender Verkehr (Einzelplatzdetektion)'],
    },
    {
        id: 'SmartIllegalParking',
        titleKey: 'tiles.smartIllegalParking.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartIllegalParkingImage,
        categories: ['traffic'],
        navigateTo: '/SmartIllegalParking',
        icon: IconParkAndCharge,
        tabs: ['Widerrechtliches Parken'],
    },
    {
        id: "SmartAverageSpeed",
        titleKey: 'tiles.smartAverageSpeed.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartAverageSpeedImage,
        categories: ["traffic"],
        navigateTo: "/SmartAverageSpeed",
        icon: IoSpeedometer,
        tabs: ['Fließender Verkehr', "Fließender Verkehr mit FCD"],
    },
    {
        id: "RealTimeTraffic",
        titleKey: 'tiles.realTimeTraffic.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: RealTimeTrafficImage,
        categories: ['traffic'],
        navigateTo: "/RealTimeTraffic",
        tabs: ['Fließender Verkehr mit FCD'],
        icon: FaTrafficLight,
    },
    {
        id: "SmartRealTimeTraffic",
        titleKey: 'tiles.smartRealTimeTraffic.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartRealTimeTrafficImage,
        categories: ['traffic'],
        navigateTo: "/SmartRealTimeTraffic",
        icon: FaTrafficLight,
        tabs: ['Fließender Verkehr mit FCD'],
    },
    {
        id: 'SmartPedestrian',
        titleKey: 'tiles.smartPedestrian.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartPedestrianImage,
        categories: ['environment', 'traffic'],
        navigateTo: '/SmartPedestrian',
        icon: FaWalking,
        tabs: ['Umwelt'],
    },
    {
        id: 'SmartPedestrianOccupancy',
        titleKey: 'tiles.pedestrianOccupancy.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartPedestrianOccupancyImage,
        categories: ['traffic'],
        navigateTo: '/SmartPedestrianOccupancy',
        tabs: ['Passantenaufkommen'],
        icon: FaWalking,
    },
    {
        id: 'Parksuchverkehr',
        titleKey: 'tiles.parkingSearch.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ParksuchverkehrImage,
        categories: ['traffic'],
        navigateTo: '/Parksuchverkehr',
        icon: MdOutlineLocalParking,
        tabs: ['Ruhender Verkehr (Einzelplatzdetektion) mit FCD', "Ruhender Verkehr (Bilanzierendes Parken) mit FCD"],
    },
    {
        id: 'Verkehrsaufkommen',
        titleKey: 'tiles.trafficVolume.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: VerkersaufkommenImage,
        categories: ['traffic'],
        navigateTo: '/Verkehrsaufkommen',
        icon: FaTrafficLight,
        tabs: ["Fließender Verkehr mit FCD"],
    },
    {
        id: 'Verlustzeiten',
        titleKey: 'tiles.lostTime.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: VerlustzeitenImage,
        categories: ['traffic'],
        navigateTo: '/Verlustzeiten',
        icon: MdOutlineTimer,
        tabs: ["Fließender Verkehr mit FCD"],
    },
    {
        id: 'Parkverteilung',
        titleKey: 'tiles.parkingDistribution.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ParkverteilungImage,
        categories: ['traffic'],
        navigateTo: '/Parkverteilung',
        icon: MdDirectionsCar,
        tabs: ['Ruhender Verkehr (Einzelplatzdetektion) mit FCD', 'Ruhender Verkehr (Bilanzierendes Parken) mit FCD'],
    },
    {
        id: 'QuelleZielBögen',
        titleKey: 'tiles.sourceDestination.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: QuelleZielAuswertungImage,
        categories: ['traffic'],
        navigateTo: '/QuelleZielBögen',
        icon: FaShareAlt,
        tabs: ['Fließender Verkehr mit FCD'],
    },
    {
        id: 'Verkehrsspinne',
        titleKey: 'tiles.trafficSpider.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: VerkersspinneImage,
        categories: ['traffic'],
        navigateTo: '/Verkehrsspinne',
        icon: GiSpiderWeb,
    },
    {
        id: 'LevelOfService',
        titleKey: 'tiles.levelOfService.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: LevelOfServiceImage,
        categories: ['traffic'],
        navigateTo: '/LevelOfService',
        icon: MdMood,
        tabs: ['Fließender Verkehr mit FCD'],
    },
    {
        id: 'Parkdauer',
        titleKey: 'tiles.parkdauer.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ParkdauerImage,
        categories: ['traffic'],
        navigateTo: '/Parkdauer',
        icon: MdOutlineTimer,
        tabs: ['Ruhender Verkehr (Einzelplatzdetektion) mit FCD'],
    },
    {
        id: 'InterflowingTrafficFlows',
        titleKey: 'tiles.InterflowingTrafficFlows.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: AgorgaFCDImage,
        categories: ['traffic'],
        navigateTo: '/InterflowingTrafficFlows',
        icon: PiTrafficConeFill,
        tabs: ['Fließender Verkehr mit FCD'],
    },
    {
        id: 'SmartEnvironment',
        titleKey: 'tiles.smartEnvironment.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartEnvironmentExampleImage,
        categories: ['environment'],
        navigateTo: '/SmartEnvironment',
        icon: FaTint,
        tabs: ['Kommunale Bewässerung'],
    },
    {
        id: 'SmartNaturalEvents',
        titleKey: 'tiles.smartNaturalEvents.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartNaturalEventsImage,
        categories: ['environment'],
        navigateTo: '/SmartNaturalEvents',
        icon: FaRoad,
        tabs: ['Winterdienst'],
    },
    {
        id: 'SmartNoise',
        titleKey: 'tiles.smartNoise.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartNoiseImage,
        categories: ['environment'],
        navigateTo: '/SmartNoise',
        icon: GiSoundWaves,
        tabs: ['Umwelt'],
    },
    {
        id: 'SmartEmissions',
        titleKey: 'tiles.smartEmissions.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartEmissionsImage,
        categories: ['environment'],
        navigateTo: '/SmartEmissions',
        icon: FaSmog,
        tabs: ['Umwelt'],
    },
    {
        id: 'SmartEmissions_v2',
        titleKey: 'tiles.smartEmissions.title_v2',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartEmissionsImage_v2,
        categories: ['environment'],
        navigateTo: '/SmartEmissions_v2',
        icon: FaSmog,
        tabs: ['Umwelt'],
    },
    {
        id: 'SmartWasteDisposal',
        titleKey: 'tiles.smartWasteDisposal.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartWasteDisposalImage,
        categories: ['environment'],
        navigateTo: '/SmartWasteDisposal',
        icon: FaTrash,
        tabs: ['Kommunale Mülleimer'],
    },
    {
        id: 'SmartEnergyMonitoring',
        titleKey: 'tiles.smartEnergyMonitoring.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartEnergyMonitoringImage,
        categories: ['energy'],
        navigateTo: '/SmartEnergyMonitoring',
        icon: SlEnergy,
    },
    {
        id: "SmartWaterLevel",
        titleKey: 'tiles.smartWaterLevel.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartWaterLevelImage,
        categories: ["environment"],
        navigateTo: "/SmartWaterLevel",
        icon: IoIosWater,
        tabs: ['Kommunale Pegel'],
    },
    {
        id: "SmartWaterQuality",
        titleKey: 'tiles.smartWaterQuality.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartWaterLevelImage,
        categories: ["environment"],
        navigateTo: "/SmartWaterQuality",
        icon: FaHandHoldingWater,
        tabs: ['Kommunale Gewässerqualität'],
    },
    {
        id: "SmartPrecipitation",
        titleKey: 'tiles.precipitation.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartWaterLevelImage,
        categories: ["environment"],
        navigateTo: "/SmartPrecipitation",
        icon: IoIosRainy,
        tabs: ['Umwelt'],
    },
    {
        id: "FloodRisk",
        titleKey: 'tiles.floodRisk.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartFloodRiskImage,
        categories: ["environment"],
        navigateTo: "/FloodRisk",
        icon: RiFloodFill,
        tabs: ['Kommunale Pegel'],
    },
    {
        id: "FloodRiskManager",
        titleKey: 'tiles.floodRiskManager.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartFloodRiskManagerImage,
        categories: ["environment"],
        navigateTo: "/FloodRiskManager",
        icon: SiFlood,
    },
    {
        id: "HeatIsland",
        titleKey: 'tiles.heatIsland.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: HeatIslandImage,
        categories: ["environment"],
        navigateTo: "/HeatIsland",
        icon: Temperature,
        tabs: ['Kommunale Hitzeinseln'],
    },
    {
        id: "SmartHeatIsland",
        titleKey: 'tiles.smartHeatIsland.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartHeatIslandImage,
        categories: ["environment"],
        navigateTo: "/SmartHeatIsland",
        icon: Temperature,
        tabs: ['Kommunale Hitzeinseln'],
    },
    {
        id: "ParkingMeterData",
        titleKey: 'tiles.parkingMeterData.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: M2L_1Image,
        categories: ["traffic"],
        navigateTo: "/ParkingMeterData",
        icon: IoTicket,
        tabs: ['Parkscheinautomaten'],
    },
    {
        id: "ParkingMeterStats",
        titleKey: 'tiles.parkingMeterStats.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: M2L_2Image,
        categories: ["traffic"],
        navigateTo: "/ParkingMeterStats",
        icon: IoTicket,
        tabs: ['Parkscheinautomaten'],
    },
    {
        id: "ParkingMeterAnalysis",
        titleKey: 'tiles.parkingMeterAnalysis.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ParkingMeterAnalysisImage,
        categories: ['traffic'],
        navigateTo: "/ParkingMeterAnalysis",
        icon: IoTicket,
        tabs: ['Parkscheinautomaten'],
    },
    {
        id: "ParkingViolations",
        titleKey: 'tiles.parkingViolations.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: M2L_3Image,
        categories: ["traffic"],
        navigateTo: "/ParkingViolations",
        icon: IoTicket,
        tabs: ['Parkscheinautomaten'],
    },
    {
        id: "Parkverstoesse",
        titleKey: 'tiles.smartIllegalParking.parkingViolations',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ParkverstoesseImage,
        categories: ['traffic'],
        navigateTo: "/Parkverstoesse",
        icon: BsFillSignNoParkingFill,
    },
    {
        id: "CurrentTrafficSituation",
        titleKey: 'tiles.currentTrafficSituation.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: Rodgau_1Image,
        categories: ["traffic"],
        navigateTo: "/CurrentTrafficSituation",
        icon: Car,
        tabs: ['Fließender Verkehr mit FCD'],
    },
    {
        id: "TrafficData",
        titleKey: 'tiles.trafficData.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: Rodgau_2Image,
        categories: ["traffic"],
        navigateTo: "/TrafficData",
        icon: Car,
        tabs: ['Fließender Verkehr mit FCD'],
    },
    {
        id: "TrafficAnalyzer",
        titleKey: 'tiles.trafficAnalyzer.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: Rodgau_2Image,
        categories: ["traffic"],
        navigateTo: '/',
        linkTo: trafficAnalyzerUrl || undefined,
        icon: Car,
    },
    {
        id: "DownloadManager",
        titleKey: 'tiles.downloadManager.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: DownloadManagerImage,
        categories: ["utility", "environment", "traffic", "energy"],
        navigateTo: "/DownloadManager",
        icon: FaCloudDownloadAlt,
        tabs: ['Passantenaufkommen', 'Winterdienst', 'Kommunaler Wald', 'Kommunale Hitzeinseln', 'Umwelt', 'Kommunale Pegel', 'Kommunale Gewässerqualität', 'Kommunale Bewässerung', 'Kommunale Mülleimer', 'Parkscheinautomaten', "Ruhender Verkehr (Bilanzierendes Parken)", "Ruhender Verkehr (Bilanzierendes Parken) mit FCD", "Ruhender Verkehr (Einzelplatzdetektion)", "Ruhender Verkehr (Einzelplatzdetektion) mit FCD", "Widerrechtliches Parken", "Fließender Verkehr", "Fließender Verkehr mit FCD", "Starkregen"],
    },
    {
        id: "Questionnaire",
        titleKey: 'tiles.Questionnaire.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: QuestionnaireImage,
        categories: ["utility"],
        navigateTo: "/Questionnaire",
        icon: FaRegClipboard,
        tabs: ['Doughnut Management'],
    },
    {
        id: "QuestionnaireOverview",
        titleKey: 'tiles.QuestionnaireOverview.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: QuestionnaireOverviewImage,
        categories: ["utility"],
        navigateTo: "/QuestionnaireOverview",
        icon: FaChartPie,
        tabs: ['Doughnut Management'],
    },
    {
        id: "SpendingPulse",
        titleKey: 'tiles.spendingPulse.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SpendingPulseImage,
        categories: ["utility"],
        navigateTo: "/SpendingPulse",
        icon: BsClipboardPulse,
        tabs: ['Wirtschaft'],
    },
    {
        id: "GeoInsights",
        titleKey: 'tiles.geoInsights.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: GeoInsightsImage,
        categories: ["utility"],
        navigateTo: "/GeoInsights",
        icon: MdInsights,
        tabs: ['Wirtschaft'],
    },
    {
        id: "ForestFireMonitoring",
        titleKey: 'tiles.ForestFireMonitoring.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ForestFireMonitoringImage,
        categories: ["environment"],
        navigateTo: "/ForestFireMonitoring",
        icon: GiBurningForest,
        tabs: ['Kommunaler Wald'],
    },
    {
        id: "ForestFireVulnerability",
        titleKey: 'tiles.ForestFireVulnerability.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ForestFireVulnerabilityImage,
        categories: ["environment"],
        navigateTo: "/ForestFireVulnerability",
        icon: GiBurningForest,
        tabs: ['Kommunaler Wald'],
    },
    {
        id: "WeatherMonitoring",
        titleKey: 'tiles.WeatherMonitoring.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: WeatherMonitoringImage,
        categories: ["utility", "environment", "traffic", "energy", "utility"],
        navigateTo: "/WeatherMonitoring",
        icon: PartlyCloudyDay,
        tabs: ['Passantenaufkommen', 'Winterdienst', 'Kommunaler Wald', 'Kommunale Hitzeinseln', 'Umwelt', 'Kommunale Pegel', 'Kommunale Gewässerqualität', 'Kommunale Bewässerung', 'Kommunale Mülleimer', 'Parkscheinautomaten', "Ruhender Verkehr (Bilanzierendes Parken)", "Ruhender Verkehr (Bilanzierendes Parken) mit FCD", "Ruhender Verkehr (Einzelplatzdetektion)", "Ruhender Verkehr (Einzelplatzdetektion) mit FCD", "Widerrechtliches Parken", "Fließender Verkehr", "Fließender Verkehr mit FCD", "Starkregen"],
    },
    {
        id: "WinterService",
        titleKey: 'tiles.WinterService.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: WinterServiceImage,
        categories: ["environment"],
        navigateTo: "/WinterService",
        icon: FaSnowplow,
        tabs: ['Winterdienst'],
    },
    {
        id: "WeatherMeteoblueMap",
        titleKey: 'tiles.WeatherMeteoblueMap.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: WeatherMeteoblueMapImage,
        categories: ["environment"],
        navigateTo: "/WeatherMeteoblueMap",
        icon: TbMapCog,
        tabs: ['Kommunaler Wald', 'Kommunale Hitzeinseln', 'Umwelt'],
    },
    {
        id: "ForestHealth",
        titleKey: 'tiles.ndvi.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ForestHealthImage,
        categories: ["environment"],
        tabs: ["Kommunaler Wald"],
        navigateTo: "/ForestHealth",
        icon: MdOutlineForest,
    },
    {
        id: "ForestHealthManager",
        titleKey: 'tiles.forestHealth.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: ForestHealthManagerImage,
        categories: ["environment"],
        navigateTo: "/ForestHealthManager",
        icon: MdOutlineForest,
        tabs: ['Kommunaler Wald'],
    },
    {
        id: "SmartSurfaceWater",
        titleKey: 'tiles.surfaceWater.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartSurfaceWaterImage,
        categories: ["environment"],
        navigateTo: "/SmartSurfaceWater",
        icon: FaArrowUpFromWaterPump,
        tabs: ['Umwelt', 'Starkregen'],
    },

    {
        id: "SmartBikeTraffic",
        titleKey: 'tiles.bikeTraffic.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: BikeTrafficImage,
        categories: ['traffic'],
        navigateTo: "/SmartBikeTraffic",
        icon: MdDirectionsBike,
    },
    {
        id: "SmartPedestrianTraffic",
        titleKey: 'tiles.pedestrianTraffic.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: PedestrianTrafficImage,
        categories: ['traffic'],
        navigateTo: "/SmartPedestrianTraffic",
        icon: FaWalking,
    },
    {
        id: "EventManager",
        titleKey: 'tiles.EventManager.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: PedestrianTrafficImage,
        icon: FaSunPlantWilt,
        navigateTo: "/landing",
        categories: [],
    },
    {
        id: "PromptLibrary",
        titleKey: 'categoryTabs.utility.promptLibrary.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: PedestrianTrafficImage,
        icon: FaSunPlantWilt,
        navigateTo: "/PromptLibrary",
        categories: ["utility"],
        tabs: ['Prompt Bibliothek'],
    },
    {
        id: "SmartFeuerwehrzufahrten",
        titleKey: 'tiles.smartFeuerwehrzufahrten.title',
        subtitleKey: 'tiles.common.subtitle',
        descriptionKey: 'tiles.common.description',
        image: SmartParkingSpotsImage,
        categories: ["traffic"],
        navigateTo: "/SmartFeuerwehrzufahrten",
        icon: MdFireTruck,
        tabs: ['Ruhender Verkehr (Einzelplatzdetektion)'],
    },
];

export const useTranslatedTilesData = () => {
    const { t } = useTranslation();
    return tilesData.map(tile => ({
        ...tile,
        title: t(tile.titleKey),
        subtitle: t(tile.subtitleKey),
        description: t(tile.descriptionKey)
    }));
};

export const getIconForTile = (id: string): IconType | React.FC<IconProps> => {
    const tile = tilesData.find(tile => tile.id === id);
    if (tile) {
        return tile.icon;
    }
    // Default icons for categories
    switch (id) {
        case 'traffic':
            return Car;
        case 'environment':
            return FaTint;
        case 'energy':
            return SlEnergy;
        case 'utility':
            return FaRegClipboard;
        default:
            return FaTint;
    }
};

export const renderIcon = (Icon: IconType | React.FC<IconProps>, props: { color: string; size: number }) => {
    return <Icon {...props} />;
};